// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");

function Expln_React_TextFileReader(props) {
  var onChange = props.onChange;
  return React.createElement("input", {
              type: "file",
              onChange: (function (evt) {
                  var fr = new FileReader();
                  var files = evt.nativeEvent.target.files;
                  if (files.length === 0) {
                    return onChange(undefined);
                  }
                  var file = files[0];
                  var fileName = file.name;
                  fr.onload = (function () {
                      var fileText = fr.result;
                      onChange([
                            fileName,
                            fileText
                          ]);
                    });
                  fr.readAsBinaryString(file);
                })
            });
}

var make = Expln_React_TextFileReader;

exports.make = make;
/* react Not a pure module */
